module.exports = __webpack_public_path__ + "media/scripts/pages/join/assets/media/bts/bts-image@2x-01675fea2053ab68088158ad239fdc97.jpg";